<adapt-dialog [maxWidth]="1200">
    <h3 adapt-dialog-title>{{ title }}</h3>

    <div adapt-dialog-content>
        <adapt-configure-team-stewardship [team]="team"
                                          (areAllEditorsValid)="areEditorsValid = $event"></adapt-configure-team-stewardship>
    </div>

    <adapt-standard-dialog-buttons adapt-dialog-footer
                                   [discardConfirmationInstance]="instance"
                                   [saveIsDisabled]="disabled || !areEditorsValid"> </adapt-standard-dialog-buttons>
</adapt-dialog>
